import React, {   useState } from 'react'
import {  Form, Input, App,Modal } from 'antd'
import { usePingtaiTypeAddMutation } from '../../../store/DianShangYeWuApi';
import Icon from '../../../cpn/Icon';
function ShopAdd(props) {
    const [open,setOpen] = useState(false)
    const{message} = App.useApp();    
    const [form] = Form.useForm(); 
    const [submit] = usePingtaiTypeAddMutation();
    const [info,setInfo] = useState({
        dspt_name: '',
        dspt_qy_id: props.qy_id,
        dspt_qy_name: props.qy_name,
        dspt_uid: props.yh_id,
        dspt_uname: props.yh_name,
    })
    return (
        <>
            <Icon type='add' onClick={() => {setOpen(true)}} />
            <Modal
                open={open}
                title='新增店铺'
                width={800}
                onCancel={() => {setOpen(false)}} 
                onOk={() => {                    
                    submit(info).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {                            
                            message.success('新增成功')   
                            form.resetFields();  
                            setOpen(false);
                        }
                        if (res.data.Status === 'fail') {
                            message.error('新增失败：'+res.data.Message)
                        }
                    }) 
                }}            
            >
                <Form                                
                    form={form}
                    style={{width: '100%' }}
                    layout="horizonal"
                    name="form_client"
                    initialValues={{
                        modifier: 'public',
                    }}
                    labelCol={{ span: 5}}                                 
                >   
                    <Form.Item name="dspt_name" wrapperCol={{span:10}} required label='名称'>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,dspt_name:e.target.value}))
                        }}/>
                    </Form.Item>                       
                </Form>
            </Modal>
        </>
    )
}

export default ShopAdd